import React from 'react';
import { useNode } from '@craftjs/core';
import { Grid, Slider, RadioGroup, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { ToolbarDropdown } from './ToolbarDropdown';
import { ToolbarTextInput } from './ToolbarTextInput';

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(1),
  },
  label: {
    fontSize: '11px',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
  },
  slider: {
    padding: theme.spacing(0.5, 0),
  },
}));

export const ToolbarItem = ({ full = false, propKey, type, onChange, onSelect, index, debounce, ...props }) => { 
  const classes = useStyles();
  const {
    actions: { setProp },
    propValue,
  } = useNode((node) => ({
    propValue: propKey && node.data.props[propKey],
  }));

  const value = Array.isArray(propValue) ? propValue[index] : propValue;

  const debounceTime = debounce !== undefined ? debounce : (type === 'slider' ? 200 : 500); 
  
  const isLiveUpdate = debounceTime === 0; 

  const handlePropChange = (newValue) => {
    if (!propKey) return;
    
    const updateProp = (props) => {
      const finalValue = onChange ? onChange(newValue) : newValue;
      if (Array.isArray(propValue)) {
        props[propKey][index] = finalValue;
      } else {
        props[propKey] = finalValue;
      }
    };
    
    if (debounceTime === 0) {
        setProp(updateProp, 0);
    } else {
        setProp(updateProp, debounceTime); 
    }
  };

  const renderItem = () => {
    switch (type) {
      case 'text':
      case 'color':
      case 'bg':
      case 'number':
        return (
          <ToolbarTextInput
            {...props}
            type={type}
            value={value}
            onChange={handlePropChange}
            isLiveUpdate={isLiveUpdate} 
          />
        );
      case 'slider':
        return (
          <>
            {props.label && (
              <Typography variant="caption" className={classes.label}>
                {props.label}
              </Typography>
            )}
            <Slider
              className={classes.slider}
              value={parseInt(value) || 0}
              onChange={(_, sliderValue) => handlePropChange(sliderValue)} 
              {...props}
            />
          </>
        );
      case 'radio':
        return (
          <>
            {props.label && (
              <Typography variant="caption" className={classes.label}>
                {props.label}
              </Typography>
            )}
            <RadioGroup
              value={value || ''}
              onChange={(e) => handlePropChange(e.target.value)} 
              {...props}
            >
              {props.children}
            </RadioGroup>
          </>
        );
      case 'select':
        return (
          <ToolbarDropdown
            value={value || ''}
            onChange={(dropdownValue) => handlePropChange(dropdownValue)}
            onSelect={onSelect}
            {...props}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Grid item xs={full ? 12 : 6}>
      <div className={classes.root}>
        {renderItem()}
      </div>
    </Grid>
  );
};
